import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { Icon, l, palettes } from '@manychat/manyui'

import FlowTextViewer from 'common/builder/components/misc/FlowTextViewer'
import FieldIcon from 'common/fields/components/FieldIcon'

import { FilterField } from '../../../models/AudienceFilter/constants'

import cm from './ConditionSummary.module.css'

class ConditionSummary extends React.Component {
  static propTypes = {
    error: PropTypes.node,
    disabled: PropTypes.bool,
    icon: PropTypes.string,
    caption: PropTypes.string,
    operator: PropTypes.string,
    value: PropTypes.string,
    ignoreValue: PropTypes.bool,
    validValue: PropTypes.bool,
    onFieldLinkClick: PropTypes.func,
    onValueLinkClick: PropTypes.func,
    valueRef: PropTypes.func,
    customSummary: PropTypes.element,
  }

  static defaultProps = {
    disabled: false,
    ignoreValue: false,
    validValue: false,
    icon: '',
    caption: '',
    onFieldLinkClick() {},
    onValueLinkClick() {},
    valueRef() {},
    customSummary: null,
  }

  render() {
    const {
      error,
      disabled,
      icon,
      caption,
      operator,
      value,
      ignoreValue,
      validValue,
      className,
      onFieldLinkClick,
      onValueLinkClick,
      valueRef,
      field,
    } = this.props

    if (error) {
      return (
        <a
          className={cx(cm.item, disabled ? cm.disabled : 'b-b-2')}
          onClick={!disabled ? onFieldLinkClick : null}
        >
          <span className="text-danger">{error}</span>
        </a>
      )
    }

    if (field === FilterField.AI_AUTOMATION_SESSION) {
      return (
        <div className={cx(cm.condition, cm.condition_ai, className)}>
          <span className="text-body">{l.translate('Got answers from AI')}</span>

          <Icon.Ai className={cx('m-l-xxs text-secondary', cm.condition__icon)} size={16} />
        </div>
      )
    }

    return (
      <div className={cx(cm.condition, className)}>
        <a
          data-test-id="condition-item"
          className={cx(cm.item, disabled ? cm.disabled : 'b-b-2')}
          onClick={!disabled ? onFieldLinkClick : null}
        >
          {icon && (
            <div className={cm.itemIcon}>
              <FieldIcon iconName={icon} size={14} color={palettes.typography.secondary} />
            </div>
          )}
          <span className={cx(cm.caption, { [cm.withIcon]: icon })}>{caption}</span>
        </a>
        <a
          ref={valueRef}
          data-test-id="condition-item-value"
          className={cx(cm.item, disabled ? cm.disabled : 'b-b-2', 'd-flex m-l-xxs')}
          onClick={!disabled ? onValueLinkClick : null}
        >
          <span
            className={cx({
              'text-secondary': validValue,
              'm-r-xxs': !ignoreValue,
              'text-danger': !validValue,
            })}
          >
            {operator}
          </span>
          {!ignoreValue && (
            <span className="d-inline-block o-hidden">
              <FlowTextViewer value={`${value}`} preview={false} className="text-ellipsis" />
            </span>
          )}
        </a>
      </div>
    )
  }
}

export default ConditionSummary
